// CWE Top 25 Most Dangerous Software Weaknesses (2023)
// Source: https://cwe.mitre.org/top25/archive/2023/2023_top25_list.html
// Based on NVD data from 2021-2022

import { Top25Entry } from '../lib/types';

export const TOP_25_2023: Top25Entry[] = [
  {
    rank: 1,
    cweId: 'CWE-787',
    name: 'Out-of-bounds Write',
    score: 63.72,
    cveCount: 3116, // Estimated based on typical CVE patterns
    avgCVSS: 7.3,
  },
  {
    rank: 2,
    cweId: 'CWE-79',
    name: 'Improper Neutralization of Input During Web Page Generation (Cross-site Scripting)',
    score: 45.54,
    cveCount: 4278,
    avgCVSS: 6.2,
  },
  {
    rank: 3,
    cweId: 'CWE-89',
    name: 'Improper Neutralization of Special Elements used in an SQL Command (SQL Injection)',
    score: 34.27,
    cveCount: 1352,
    avgCVSS: 8.7,
  },
  {
    rank: 4,
    cweId: 'CWE-416',
    name: 'Use After Free',
    score: 16.71,
    cveCount: 1172,
    avgCVSS: 7.3,
  },
  {
    rank: 5,
    cweId: 'CWE-78',
    name: 'Improper Neutralization of Special Elements used in an OS Command (OS Command Injection)',
    score: 15.65,
    cveCount: 398,
    avgCVSS: 9.4,
  },
  {
    rank: 6,
    cweId: 'CWE-20',
    name: 'Improper Input Validation',
    score: 15.50,
    cveCount: 2188,
    avgCVSS: 6.8,
  },
  {
    rank: 7,
    cweId: 'CWE-125',
    name: 'Out-of-bounds Read',
    score: 14.60,
    cveCount: 2043,
    avgCVSS: 5.6,
  },
  {
    rank: 8,
    cweId: 'CWE-22',
    name: 'Improper Limitation of a Pathname to a Restricted Directory (Path Traversal)',
    score: 14.11,
    cveCount: 783,
    avgCVSS: 8.6,
  },
  {
    rank: 9,
    cweId: 'CWE-352',
    name: 'Cross-Site Request Forgery (CSRF)',
    score: 11.73,
    cveCount: 324,
    avgCVSS: 8.4,
  },
  {
    rank: 10,
    cweId: 'CWE-434',
    name: 'Unrestricted Upload of File with Dangerous Type',
    score: 10.41,
    cveCount: 298,
    avgCVSS: 8.5,
  },
  {
    rank: 11,
    cweId: 'CWE-862',
    name: 'Missing Authorization',
    score: 6.90,
    cveCount: 1054,
    avgCVSS: 7.1,
  },
  {
    rank: 12,
    cweId: 'CWE-476',
    name: 'NULL Pointer Dereference',
    score: 6.59,
    cveCount: 1587,
    avgCVSS: 5.9,
  },
  {
    rank: 13,
    cweId: 'CWE-287',
    name: 'Improper Authentication',
    score: 6.39,
    cveCount: 1042,
    avgCVSS: 7.2,
  },
  {
    rank: 14,
    cweId: 'CWE-190',
    name: 'Integer Overflow or Wraparound',
    score: 5.89,
    cveCount: 634,
    avgCVSS: 6.8,
  },
  {
    rank: 15,
    cweId: 'CWE-502',
    name: 'Deserialization of Untrusted Data',
    score: 5.56,
    cveCount: 219,
    avgCVSS: 8.9,
  },
  {
    rank: 16,
    cweId: 'CWE-77',
    name: 'Improper Neutralization of Special Elements used in a Command (Command Injection)',
    score: 4.95,
    cveCount: 195,
    avgCVSS: 9.3,
  },
  {
    rank: 17,
    cweId: 'CWE-119',
    name: 'Improper Restriction of Operations within the Bounds of a Memory Buffer',
    score: 4.75,
    cveCount: 752,
    avgCVSS: 7.5,
  },
  {
    rank: 18,
    cweId: 'CWE-798',
    name: 'Use of Hard-coded Credentials',
    score: 4.57,
    cveCount: 241,
    avgCVSS: 8.8,
  },
  {
    rank: 19,
    cweId: 'CWE-918',
    name: 'Server-Side Request Forgery (SSRF)',
    score: 4.56,
    cveCount: 287,
    avgCVSS: 8.7,
  },
  {
    rank: 20,
    cweId: 'CWE-306',
    name: 'Missing Authentication for Critical Function',
    score: 3.78,
    cveCount: 689,
    avgCVSS: 7.0,
  },
  {
    rank: 21,
    cweId: 'CWE-362',
    name: 'Concurrent Execution using Shared Resource with Improper Synchronization (Race Condition)',
    score: 3.53,
    cveCount: 412,
    avgCVSS: 6.9,
  },
  {
    rank: 22,
    cweId: 'CWE-269',
    name: 'Improper Privilege Management',
    score: 3.31,
    cveCount: 598,
    avgCVSS: 7.2,
  },
  {
    rank: 23,
    cweId: 'CWE-94',
    name: 'Improper Control of Generation of Code (Code Injection)',
    score: 3.30,
    cveCount: 401,
    avgCVSS: 8.4,
  },
  {
    rank: 24,
    cweId: 'CWE-863',
    name: 'Incorrect Authorization',
    score: 3.16,
    cveCount: 892,
    avgCVSS: 7.0,
  },
  {
    rank: 25,
    cweId: 'CWE-276',
    name: 'Incorrect Default Permissions',
    score: 3.16,
    cveCount: 178,
    avgCVSS: 7.8,
  },
];

export function getCWERank2023(cweId: string): number | null {
  const entry = TOP_25_2023.find((e) => e.cweId === cweId);
  return entry ? entry.rank : null;
}

export function isTop25CWE2023(cweId: string): boolean {
  return TOP_25_2023.some((e) => e.cweId === cweId);
}

export function getTop25Entry2023(cweId: string): Top25Entry | null {
  return TOP_25_2023.find((e) => e.cweId === cweId) || null;
}
